import axios from "axios";
let cancel;

export default class Dadata {
    _apiBase = '/ajax/fast-order/dadata.php';

    constructor() {
        this.cancel = null;
    }

    getResource = async (params) => {
        if (cancel != undefined) {
            cancel();
        }

        return await axios.post(this._apiBase, params,{
            cancelToken: new axios.CancelToken(function executor(c) {
                cancel = c;
            })
        }).then(value => {
            if(!value.data.length) {
                return [];
            }

            return value.data;
        }).catch(() => {
            return [];
        });
    };

    getSurname = async (value) => {
        return await this.getResource({
            "action": "get_surname",
            "q": value,
        });
    };

    getName = async (value, gender) => {
        let params = {
            "action": "get_name",
            "q": value,
        };

        if(gender) {
            params.gender = gender;
        }

        return await this.getResource(params);
    };

    getCity = async (value) => {
        let params = {
            "action": "get_city",
            "q": value,
        };

        return await this.getResource(params);
    };

    getStreet = async (value, city, settlement) => {
        let params = {
            "action": "get_street",
            "q": value,
        };

        if(city) {
            params.city = city;
        }
        if(settlement) {
            params.settlement = settlement;
        }

        return await this.getResource(params);
    };

    getHouse = async (value, settlement, street) => {
        let params = {
            "action": "get_house",
            "q": value,
        };

        if(settlement) {
            params.settlement = settlement;
        }
        if(street) {
            params.street = street;
        }

        return await this.getResource(params);
    };
}
